import { ApiError } from "@/lib/api/client";
import { acceptInvitation } from "@/lib/api/endpoints";
import { writeActiveCustomerCookie } from "@/lib/mapper/active-customer-cookie";

type Result = { ok: true; workspaceId: string } | { ok: false; error: string };

/** Accept a pending invitation, make that workspace active, and report its id. */
export async function acceptInvitationAction(workspaceId: string): Promise<Result> {
  if (!workspaceId) return { ok: false, error: "Missing invitation." };
  try {
    const workspace = await acceptInvitation(workspaceId);
    const id = workspace?.id ?? workspaceId;
    writeActiveCustomerCookie(id);
    return { ok: true, workspaceId: id };
  } catch (err) {
    return {
      ok: false,
      error: err instanceof ApiError || err instanceof Error ? err.message : "Action failed",
    };
  }
}
